import { Link, Outlet } from 'react-router';
import { signOut, useCurrentUser } from '../hooks.js';

export function Header({ email }: { email?: string }) {
  return (
    <header className="site-header">
      <div className="inner">
        <Link to="/" className="brand">
          <span className="brand-dot" aria-hidden="true" />
          Builder console
        </Link>
        <span className="spacer" />
        {email ? (
          <>
            <span className="who" title={email}>
              {email}
            </span>
            <button type="button" className="btn btn-sm" onClick={() => void signOut()}>
              Sign out
            </button>
          </>
        ) : null}
      </div>
    </header>
  );
}

/** Frame for signed-in pages. */
export function Layout() {
  const me = useCurrentUser();
  return (
    <>
      <Header email={me.email} />
      <main>
        <Outlet />
      </main>
    </>
  );
}

/** Frame for pages anyone can see. */
export function PublicLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
    </>
  );
}
